// extracted by mini-css-extract-plugin
module.exports = {"main":"main___ycd8F","title":"title___3EDyi","main-content":"main-content___2p66A","link":"link___2-k71"};